import RidesTable from './components/RidesTable'
import './rides.scss'
import Header from './components/Header'
import RideInfo from './components/RideInfo'
import Map from './components/Map'

const Rides = () => (
  <div className="rides-page-container">
    <Header />
    <div className="rides-page-content">
      <RidesTable />
      <RideInfo />
      <Map />
    </div>
  </div>
)

export default Rides
